module.exports = __webpack_public_path__ + "static/media/logo-agep.13bf4cd8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Layout/assets/img/logo-agep.svg
// module id = 1899
// module chunks = 0